import { Resource } from 'idea-toolbox';

import { Location } from './locations.model';
import { PersonTypes } from './registration.model';

/**
 * A user of the platform.
 */
export class User extends Resource {
  personType: PersonTypes;
  username: string;
  firstName: string;
  lastName: string;
  taxCode: string;
  birthdate: string;
  phone: string;
  privacyPreferences: UserPrivacyPreferences;
  homeAddress: Location;
  mailAddress: Location;

  load(x: any): void {
    super.load(x);
    this.personType = this.clean(x.personType ?? x.cdTipoAnagrafica, String, PersonTypes.PRIVATE);
    this.username = this.clean(x.username ?? x.eMail?.txRecapito, String);
    if (this.personType === PersonTypes.PRIVATE) {
      this.firstName = this.clean(x.firstName ?? x.nome ?? x.dsUtente, String);
      this.lastName = this.clean(x.lastName ?? x.cognome, String);
    } else {
      this.firstName = this.clean(x.firstName ?? x.ragioneSociale, String);
      delete this.lastName;
    }
    this.taxCode = this.clean(x.taxCode ?? x.codiceFiscale, String);
    this.birthdate = this.clean(x.birthdate ?? x.dtNascita, String);
    this.phone = this.clean(x.phone ?? x.cellulare?.txRecapito, String);
    this.privacyPreferences = new UserPrivacyPreferences(x.privacyPreferences ?? x.privacy);
    this.homeAddress = x.residenza;
    this.mailAddress = x.indirizzoCorrispondenza;
  }

  validate(): string[] {
    const e = super.validate();
    if (this.iE(this.username)) e.push('username');
    if (this.iE(this.firstName)) e.push('firstName');
    if (this.personType === PersonTypes.PRIVATE && this.iE(this.lastName)) e.push('lastName');
    if (this.iE(this.taxCode)) e.push('taxCode');
    if (this.iE(this.birthdate)) e.push('birthdate');
    if (this.iE(this.phone)) e.push('phone');
    this.privacyPreferences.validate().forEach(ea => e.push(`privacyPreferences.${ea}`));
    return e;
  }

  /**
   * Get the combination of the first name and the last name of the user.
   */
  getUserFullName(): string {
    return [this.firstName, this.lastName].join(' ');
  }
}

/**
 * Privacy preferences for a user.
 */
export class UserPrivacyPreferences extends Resource {
  commercial: boolean;
  data: boolean;
  sensibleData: boolean;
  marketing: boolean;
  thirdParty: boolean;

  load(x: any): void {
    super.load(x);
    this.commercial = this.clean(x.commercial ?? x.consensoFiniCommerciali ?? x.bConsensoFiniCommerciali, Boolean);
    this.data = this.clean(x.data ?? x.consensoDati ?? x.bConsensoDati, Boolean);
    this.sensibleData = this.clean(x.sensibleData ?? x.consensoDatiSensibili ?? x.bConsensoDatiSensibili, Boolean);
    this.marketing = this.clean(x.marketing ?? x.consensoMarketing ?? x.bConsensoProfilazioneMarketing, Boolean, false);
    this.thirdParty = this.clean(
      x.thirdParty ?? x.consensoCommercialeVersoTerzi ?? x.bConsensoCommercialeVersoTerzi,
      Boolean,
      false
    );
    if (this.sensibleData && this.marketing && this.thirdParty) this.data = true;
  }

  validate(): string[] {
    const e = super.validate();
    if (!this.commercial) e.push('commercial');
    if (!this.data) e.push('data');
    // if (!this.sensibleData) e.push('sensibleData');
    return e;
  }

  checkAllDataRelatedPreferences(state: boolean): void {
    this.sensibleData = state;
  }
}
